"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../Style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//renders thge form
var RenderApplication = function RenderApplication(props) {
  console.log(props);
  var sendApplying = function sendApplying() {
    props.sendApplication(false);
  };

  var voornaamInputRef = (0, _react.useRef)();
  var achternaamInputRef = (0, _react.useRef)();
  var emailInputRef = (0, _react.useRef)();
  var telInputRef = (0, _react.useRef)();
  var teloudersInputRef = (0, _react.useRef)();
  var straatInputRef = (0, _react.useRef)();
  var postcodeInputRef = (0, _react.useRef)();
  var gemeenteInputRef = (0, _react.useRef)();
  var geboortedagInputRef = (0, _react.useRef)();
  var geboorteplaatsInputRef = (0, _react.useRef)();
  var motivatieInputRef = (0, _react.useRef)();
  var functieInputRef = (0, _react.useRef)();

  var postApply = function postApply(e) {
    e.preventDefault();
    fetch("https://test-2e37c-default-rtdb.europe-west1.firebasedatabase.app/job_application.json", {
      method: "POST",
      body: JSON.stringify({
        voornaam: voornaamInputRef.current.value,
        achternaam: achternaamInputRef.current.value,
        email: emailInputRef.current.value,
        tel: telInputRef.current.value,
        telouders: teloudersInputRef.current.value,
        straat: straatInputRef.current.value,
        postcode: postcodeInputRef.current.value,
        gemeente: gemeenteInputRef.current.value,
        geboortedag: geboortedagInputRef.current.value,
        geboorteplaats: geboorteplaatsInputRef.current.value,
        motivatie: motivatieInputRef.current.value,
        functie: functieInputRef.current.value
      }),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (res) {
      sendApplying();
      window.location.reload(false);
      // assumption: Always succeeds!
    });
  };

  var indexSelectedJob = Number(props.vacature.id[1]);

  if (props.jobfunctions[indexSelectedJob - 1] === props.vacature.title) {
    props.jobfunctions.splice(indexSelectedJob - 1, 1);
  }

  return _react2.default.createElement(
    "section",
    {
      id: "jobApplication",
      className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme].join(" ")
    },
    _react2.default.createElement(
      "div",
      { className: "jobAppWrapper" },
      _react2.default.createElement(
        "form",
        { onSubmit: postApply, className: "jobForm" },
        _react2.default.createElement(
          "h2",
          null,
          _react2.default.createElement(
            "span",
            null,
            "Become part of our team"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "jobFormWrap four" },
          _react2.default.createElement("input", {
            type: "text",
            ref: voornaamInputRef,
            placeholder: "voornaam",
            required: true
          }),
          _react2.default.createElement("input", {
            type: "text",
            ref: achternaamInputRef,
            name: "achternaam",
            placeholder: "achternaam",
            required: true
          }),
          _react2.default.createElement("input", {
            type: "text",
            ref: emailInputRef,
            name: "email",
            placeholder: "email",
            required: true
          }),
          _react2.default.createElement("input", {
            type: "text",
            ref: telInputRef,
            name: "tel",
            placeholder: "tel",
            required: true
          }),
          _react2.default.createElement("input", {
            type: "text",
            ref: teloudersInputRef,
            name: "ouders",
            placeholder: "tel ouders"
          }),
          _react2.default.createElement("input", {
            type: "text",
            ref: straatInputRef,
            name: "straat",
            placeholder: "straat",
            required: true
          }),
          _react2.default.createElement("input", {
            type: "text",
            ref: postcodeInputRef,
            name: "postcode",
            placeholder: "postcode",
            required: true
          }),
          _react2.default.createElement("input", {
            type: "text",
            ref: gemeenteInputRef,
            name: "gemeente",
            placeholder: "gemeente",
            required: true
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "jobFormWrap two" },
          _react2.default.createElement(
            "div",
            { className: "jobFormWrap-date" },
            _react2.default.createElement("input", {
              type: "date",
              ref: geboortedagInputRef,
              placeholder: "geboortedag",
              required: true
            })
          ),
          _react2.default.createElement("input", {
            type: "text",
            ref: geboorteplaatsInputRef,
            placeholder: "geboorteplaats",
            required: true
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "jobformWrap" },
          _react2.default.createElement("textarea", {
            htmlFor: "message",
            ref: motivatieInputRef,
            id: "ja_message",
            placeholder: "Motivate us",
            required: true
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "jobformWrap" },
          props.jobfunctions.length > 0 && _react2.default.createElement(
            "select",
            { name: "functions", ref: functieInputRef },
            _react2.default.createElement(
              "option",
              {
                name: "option",
                key: props.vacature.title,
                value: props.vacature.title
              },
              props.vacature.title
            ),
            props.jobfunctions.map(function (f) {
              return _react2.default.createElement(
                "option",
                { name: "option", key: f, value: f },
                f
              );
            })
          )
        ),
        _react2.default.createElement("input", {
          id: "ja_send",
          name: "submit",
          type: "submit",
          value: "Send application"
        })
      )
    )
  );
};

exports.default = RenderApplication;